// extracted by mini-css-extract-plugin
module.exports = {"grid":"_3Xnzg","autoGrid":"_1VoTx","manualGrid":"_3g8J4","isMobile":"_3QSkz","pagination":"_3t6b5"};